import cn from 'classnames';
import React from 'react';
import Button from '@creditflowresearch/uilib/Button';
import { useMissingSomethingModalContext } from '@/creditflowresearch/application/MissingSomethingModalContext';

import styles from './missingSomethingModalButton.module.scss';
import spaces from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

export interface IProps {
  className?: string,
}

const MissingSomethingModalButton = (props: IProps) => {
  const { showModal } = useMissingSomethingModalContext();

  return (
    <div className={ cn(styles.modalButtonWrapper, props.className) }>
      <Button
        dataTest="missingSomethingButton"
        variant="text"
        onClick={ showModal }
        className={ cn(styles.missingButton, spaces.mrn) }
        tabIndex={ 0 }
      >
        Missing something? Tell us.
      </Button>
    </div>
  );
};

export default MissingSomethingModalButton;
